module.exports = __webpack_public_path__ + "img/dice-icon-active.6f8dc320.svg";